import { format, parse, setHours, UTCDate } from '@/utils/dates';
import { BeneficiaryCountry, LegalEntityCountry, PayrollStatus } from '@seapoint/server/enums';
import * as Sentry from '@sentry/react';
import { Inline } from '../../../../design-system/inline/inline';
import { getCountryFlag } from '../../../../utils/get-country-flag';
import { PayrollStatusBadge } from '../payroll-status-badge/payroll-status-badge';

export type PayrollSummaryCardProps = {
  payrollName: string;
  country: BeneficiaryCountry;
  period: string;
  company: string;
  status: PayrollStatus;
};

export const PayrollSummaryCard = ({ payrollName, country, period, company, status }: PayrollSummaryCardProps) => {
  const countryFlag = getCountryFlag(country as unknown as LegalEntityCountry);
  const formattedPeriod = (() => {
    try {
      const date = parse(period, 'MMMM yyyy', new UTCDate());
      const safeDate = setHours(date, 12); // move to noon (avoid crossing date boundary due to timezone)
      const formattedDate = format(safeDate, 'MMM yyyy');
      return formattedDate;
    } catch (error) {
      Sentry.captureMessage('Could not parse period', { extra: { period, error } });
      return period;
    }
  })();
  return (
    <Inline space={2} align="center" className="flex-nowrap rounded-xl bg-white px-5 py-8 whitespace-nowrap">
      {countryFlag && (
        <img src={countryFlag} loading="eager" fetchpriority="high" className="h-5 w-5 rounded-full object-cover" />
      )}
      <span className="truncate text-lg font-medium whitespace-nowrap text-gray-900">{payrollName}</span>
      <span className="text-muted-foreground">•</span>
      <span className="whitespace-nowrap text-muted-foreground">{formattedPeriod}</span>
      <span className="text-muted-foreground">•</span>
      <span className="truncate whitespace-nowrap text-muted-foreground">{company}</span>
      <span className="text-muted-foreground">•</span>
      <PayrollStatusBadge status={status} />
    </Inline>
  );
};
